import React from "react";
import ZeusButton from "../../components/Button";
import {useInventoryReportsExport} from "./inventoryReportsTable/useInventoryReportsExport";

const InventoryReportsHeader = ({activeFilters}) => {
  const {exportCSV, exportPDF, isExporting} = useInventoryReportsExport(activeFilters);

  return (
    <div className="common-header-container">
      <ZeusButton
        className="btn_common roboto-bold"
        onClick={exportCSV}
        disabled={isExporting}
        style={{zIndex: "10"}}
      >
        {isExporting ? "EXPORTING..." : "EXPORT CSV"}
      </ZeusButton>
      <ZeusButton
        className="btn_common roboto-bold"
        onClick={exportPDF}
        disabled={isExporting}
        style={{zIndex: "10", marginLeft: "10px"}}
      >
        {isExporting ? "EXPORTING..." : "EXPORT PDF"}
      </ZeusButton>
    </div>
  );
};

export default InventoryReportsHeader;
